var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.warningZone)?_c('div',[_c('b-alert',{staticClass:"position-fixed fixed-top m-0 rounded-0 text-center",staticStyle:{"z-index":"1000"},attrs:{"variant":"warning","show":""}},[_vm._v("Olá "),_c('b',[_vm._v(_vm._s(_vm.$store.getters['auth/userName']))]),_vm._v(", você ainda está ai?")])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }